import React from 'react';

const LocationMap = () => {
  return (
    <div className="h-full w-full">
      <iframe 
        src="https://maps.google.com/maps?q=2001%20Timberloch%20Place%2C%20Suite%20500%20Woodlands%2C%20Houston%2C%20Texas%2077380&amp;t=m&amp;z=14&amp;output=embed&amp;iwloc=near" 
        title="TISSA Technology Office Location" 
        className="w-full h-full min-h-[400px]"
        frameBorder="0"
        scrolling="no"
        marginHeight="0"
        marginWidth="0"
        aria-label="2001 Timberloch Place, Suite 500 Woodlands, Houston, Texas 77380"
        loading="lazy"
      />
    </div>
  );
};

export default LocationMap;